/*document.addEventListener('DOMContentLoaded', () => {
  // Selector targets the default Shopify accordion section/block
  const accordionGroups = document.querySelectorAll('.accordion'); 

  accordionGroups.forEach(group => {
    const detailsElements = group.querySelectorAll('details');

    detailsElements.forEach(details => {
      details.addEventListener('toggle', (event) => {
        if (event.target.open) {
          detailsElements.forEach(otherDetails => {
            // Close other 'details' elements, but not the current one
            if (otherDetails !== event.target) {
              otherDetails.removeAttribute('open');
            }
          });
        }
      });
    });
  });
}); */

document.addEventListener('DOMContentLoaded', () => {
  // Target the specific summary headers inside your custom accordion
  const accordionHeaders = document.querySelectorAll('accordion-custom .details__header');

  accordionHeaders.forEach((header) => {
    header.addEventListener('click', (e) => {
      const currentDetails = header.closest('details');
      
      // We only act if the user is OPENING an accordion
      // (The click happens before the 'open' attribute is toggled by the browser)
      if (!currentDetails.hasAttribute('open')) {
        const allAccordions = document.querySelectorAll('accordion-custom details');
        
        allAccordions.forEach((details) => {
          if (details !== currentDetails && details.hasAttribute('open')) {
            // This triggers the theme's built-in close transition
            details.removeAttribute('open');
          }
        });
      }
    });
  });
});